<template>
  <div class="s7">
    <div class="container">
      <img src="@/assets/home/s7/title.png" class="title" alt="" />
      <div class="img-wrapper">
        <div class="address-wrapper">
          <p class="address">
            <img src="@/assets/home/s7/icon.png" alt="" class="icon" />
            <span>国金惠农店-五一广场惠农大厦kfc旁 </span>
          </p>
          <img src="@/assets/home/s7/left.png" class="left-img" alt="" />
          <div class="place">
            <p class="place-title">【湖南地区】</p>
            <p>长沙国金惠农店-五一广场惠农大厦KFC旁</p>
            <p>长沙解放西路店-皇后酒吧对面</p>
            <p>长沙万家丽店-万家丽国际广场一楼南门入口处</p>
            <p>长沙步行街店-黄兴南路步行商业街西厢北栋1030号</p>
            <p>常德万达广场店-武陵区万达广场星空市集1＃铺</p>
            <p>邵阳步行街店-双清区人民广场金百汇商业街美食城D023商铺</p>
          </div>
        </div>

        <div class="address-wrapper">
          <p class="address">
            <img src="@/assets/home/s7/icon.png" alt="" class="icon" />
            <span>解放西路店-皇后酒吧对面 </span>
          </p>
          <img src="@/assets/home/s7/right.png" class="left-img" alt="" />
          <div class="place">
            <p class="place-title">【湖北地区】</p>
            <p>武汉江汉路步行街店-江汉区江汉路181号俊华广场第一层A01店铺</p>
            <p>武汉万达店-江汉区民生路176号武汉万达商业广场B栋1层3室</p>

            <p class="place-title">【陕西地区】</p>
            <p>西安骡马步行街店-碑林区骡马市步行街66号钟楼站K出口右侧</p>

            <p class="place-title">【江西地区】</p>
            <p>宜春鼓楼店-宜春市袁州区鼓楼路62号20幢1-29室</p>
          </div>
        </div>
      </div>
      <div class="place-wrapper"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.s7 {
  width: 100%;
  height: 1054.89px;
  background: #e6328d;
  padding-top: 90px;
  box-sizing: border-box;
  margin: 0 auto;
  .container {
    // width: 1600px;
    height: 844.89px;
    margin: 0 auto;
    text-align: left;
    .title {
      width: 643px;
      height: 61.34px;
    }
    .img-wrapper {
      // width: 1600px;
      height: 434.89px;
      display: flex;
      justify-content: space-between;
      position: relative;
      margin-top: 60px;

      .address-wrapper {
        .address {
          width: 389px;
          height: 26px;
          line-height: 26px;
          font-size: 18px;
          color: #fff;
          .icon {
            width: 13px;
            height: 17px;
          }
          span {
            margin-left: 17px;
          }
        }
        .left-img {
          // width: 750px;
          // height: 388.89px;
          margin-top: 20px;
        }
        .place {
          margin-top: 22px;
          font-size: 18px;
          color: #fff;
          line-height: 28px;
        }
      }
    }
    .place-wrapper {
      display: flex;
      justify-content: space-between;
      height: 200px;
      div {
        width: 389px;
      }
      p {
        font-size: 18px;
        color: #fff;
      }
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .s7 {
      min-width: 1600px;
      height: 855px;
    }
    .container {
      width: 1600px;
      .left-img {
        width: 750px;
        height: 388.89px;
      }
    }
  }

  @media (min-width: 1201px) and (max-width: 1616px) {
    .s7 {
      max-height: 855px;
      height: calc(51.5%);
    }
    .container {
      width: 90%;
      .img-wrapper {
        width: 100%;
        .address-wrapper {
          width: 47%;
        }
        .left-img {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .s7 {
      width: 1200px;
      height: 718px;
    }
    .container {
      width: 1083px;
      .img-wrapper {
        width: 1083px;

        .left-img {
          width: 486px;
        }
      }
    }
  }
}
</style>
